/**
 * @generated SignedSource<<765a4f63b2ce7fe78ae0949ca0c609a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type contentNoteTemplateQuery$variables = {
  templateId: string;
};
export type contentNoteTemplateQuery$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToPromptHeadings: boolean;
    };
  };
  readonly node: {
    readonly proseDoc?: any;
    readonly schemaVersion?: number;
  } | null;
};
export type contentNoteTemplateQuery = {
  response: contentNoteTemplateQuery$data;
  variables: contentNoteTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "templateId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "proseDoc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schemaVersion",
      "storageKey": null
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
},
v3 = {
  "alias": "hasAccessToPromptHeadings",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "prompt_headings"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contentNoteTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAccount",
            "kind": "LinkedField",
            "name": "billingAccount",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contentNoteTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAccount",
            "kind": "LinkedField",
            "name": "billingAccount",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dd0fe3267e6b7d2f6a2cc1ecd6499986",
    "id": null,
    "metadata": {},
    "name": "contentNoteTemplateQuery",
    "operationKind": "query",
    "text": "query contentNoteTemplateQuery(\n  $templateId: ID!\n) {\n  node(id: $templateId) {\n    __typename\n    ... on NoteTemplateNode {\n      proseDoc\n      schemaVersion\n    }\n    id\n  }\n  account {\n    billingAccount {\n      hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "55af7364a4933061c89d0a4a8787df58";

export default node;
